import React, { useState, useEffect } from 'react';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import { MdEmail } from 'react-icons/md';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import 'react-tabs/style/react-tabs.css';
import '../assets/style/prices.scss';

const Prices = () => {
  const [slideStyles, setSlideStyles] = useState({});
  const tabs = ['Basic', 'Standard', 'Premium'];
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const handleDropdownChange = (e) => {
    const selectedIndex = tabs.findIndex((tab) => tab === e.target.value);
    if (selectedIndex !== -1) {
      setSelectedTabIndex(selectedIndex);
    }
  };

  const handleAnchorClick = (e) => {
    e.preventDefault();

    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const moveSlide = (tabItem) => {
    const tabWidth = tabItem.offsetWidth;
    const tabOffset = tabItem.offsetLeft;

    const newSlideStyles = {
      transform: `translateX(${tabOffset}px)`,
      width: `${tabWidth}px`,
    };

    setSlideStyles(newSlideStyles);
  };

  useEffect(() => {
    const firstTab = document.querySelector('.first-tab'); // Select the first tab
    if (firstTab) {
      moveSlide(firstTab); // Call moveSlide with the first tab's DOM element
    }

    const innerScrolls = document.querySelectorAll('.react-tabs__tab-panel');

    const handleWheel = (event) => {
      event.stopPropagation();
    };

    innerScrolls.forEach((innerScroll) => {
      innerScroll.addEventListener('wheel', handleWheel);
    });
  }, []);

  return (
    <>
      <Tabs className="tabs-wrapper--mobile" onSelect={() => { }} selectedIndex={selectedTabIndex}>
        <p className="tabs-header">Quality meets affordability in every price.</p>
        <TabList style={{ display: 'none' }}>
          <Tab>Title 1</Tab>
          <Tab>Title 2</Tab>
          <Tab>Title 3</Tab>
        </TabList>
        <select
          className="dropdown-select"
          onChange={handleDropdownChange}
        >
          {tabs.map((tabName) => (
            <option key={tabName} value={tabName}>
              {tabName}
            </option>
          ))}
        </select>

        <TabPanel>
          <div className="tabpanel-content2">

            {/* <ConfettiContainer /> */}
            <div className="tabpanel-content--column-one">
              <div className="tabpanel-content--front col-basic">
                <div className="ribbon ribbon-top-left"><span>BASIC</span></div>
                <p style={{
                  bottom: '0', padding: '0 10px', position: 'absolute', fontWeight: '700', color: '#fff', width: '100%',
                }}
                >
                  Custom pricing (depending on project complexity)
                </p>
              </div>

              <div className="tabpanel-content--back">
                <h2 style={{ textAlign: 'center' }}>IMPORTANT:</h2>
                <ul>
                  <li>Prices are estimates and can vary based on project requirements.</li>
                  <li>A detailed project scope will be provided before any work begins.</li>
                  <li>Customized packages and pricing are available upon request.</li>
                  <li>
                    Prices do not include domain registration,
                    hosting fees, or third-party software licenses.
                  </li>
                </ul>
              </div>
            </div>

            <div className="tabpanel-content--column-two">
              <div className="col-two-basic-bg" />
              <table>
                <tbody>
                  <tr>
                    <td>
                      Responsive design (up to 5 pages)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Contact form integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Basic SEO optimization
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Hosting setup assistance
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customizable elements (colors, fonts, logo)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social media links integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Image gallery inclusion
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      About and Contact pages
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Blog section setup
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Initial content upload (provided by you)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Basic analytics setup
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="tabpanel-content2">
            {/* <ConfettiContainer /> */}
            <div className="tabpanel-content--column-one">
              <div className="tabpanel-content--column-one-flash" />
              <div className="tabpanel-content--front col-standard">
                <div className="ribbon ribbon-top-left"><span>STANDARD</span></div>
                <p style={{
                  bottom: '0', padding: '0 10px', position: 'absolute', fontWeight: '700', color: '#fff', width: '100%',
                }}
                >
                  Custom pricing (depending on project complexity)
                </p>
              </div>

              <div className="tabpanel-content--back">
                <h2 style={{ textAlign: 'center' }}>IMPORTANT:</h2>
                <ul>
                  <li>Prices are estimates and can vary based on project requirements.</li>
                  <li>A detailed project scope will be provided before any work begins.</li>
                  <li>Customized packages and pricing are available upon request.</li>
                  <li>
                    Prices do not include domain registration,
                    hosting fees, or third-party software licenses.
                  </li>
                </ul>
              </div>
            </div>
            <div className="tabpanel-content--column-two">
              <div className="col-two-standard-bg" />
              <table>
                <tbody>
                  <tr>
                    <td>
                      Responsive Design (up to 10 pages)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Content Management System (CMS)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Basic SEO Setup
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Contact Form
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social Media Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Google Analytics Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Stock Images
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Domain and Hosting Assistance
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Security Features
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Contact Form Integration (Advanced Fields)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Comprehensive SEO Optimization
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Hosting Setup Assistance and Configuration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Extensive Customization (Colors, Fonts, Logo)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Image Gallery (Advanced Sorting)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      About Us and Contact Us Pages
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Robust Blog Section Setup (Categories, Tags)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Initial Content Upload (Provided)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Basic Analytics Setup
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="tabpanel-content2">
            {/* <ConfettiContainer /> */}
            <div className="tabpanel-content--column-one">
              <div className="tabpanel-content--column-one-crown" />
              <div className="tabpanel-content--front col-premium">
                <div className="ribbon ribbon-top-left"><span>PREMIUM</span></div>
                <p style={{
                  bottom: '0', padding: '0 10px', position: 'absolute', fontWeight: '700', color: '#fff', width: '100%',
                }}
                >
                  Custom pricing (depending on project complexity)
                </p>
              </div>

              <div className="tabpanel-content--back">
                <h2 style={{ textAlign: 'center' }}>IMPORTANT:</h2>
                <ul>
                  <li>Prices are estimates and can vary based on project requirements.</li>
                  <li>A detailed project scope will be provided before any work begins.</li>
                  <li>Customized packages and pricing are available upon request.</li>
                  <li>
                    Prices do not include domain registration,
                    hosting fees, or third-party software licenses.
                  </li>
                </ul>
              </div>
            </div>
            <div className="tabpanel-content--column-two">
              <div className="col-two-premium-bg" />
              <table>
                <tbody>
                  <tr>
                    <td>
                      Design and Development (Up to 15 pages)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Advanced SEO Optimization
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Custom Contact Form
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Google Analytics Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Premium Stock Images
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Enhanced Security Features
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Advanced Contact Form Integration (Conditional Logic)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Comprehensive SEO Strategy (On-page and Off-page)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      E-commerce Integration (if applicable)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Custom Branding and Design (Colors, Fonts, Logo)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Image Gallery (Advanced Sorting, Filtering)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Engaging About Us and Contact Us Pages
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Robust Blog Section Setup (Categories, Tags, Comments)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      Initial Content Upload (Provided)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      In-depth Analytics and Reporting (Custom Event Tracking, Conversions)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Newsletter Signup Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Ongoing Support and Maintenance
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Video Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Infographics
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Live Chat Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Testimonial Showcase
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Multi-language Support
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Integrated Booking System
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User-generated Content
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Event Calendar
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Membership Area
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Maps
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Virtual Tours
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Parallax Scrolling
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customized 404 Page
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Polls and Surveys
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Integrated Blogging Platform
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Gamification Elements
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Product Comparison Tables
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Progressive Web App (PWA) Features
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social Proof Pop-ups
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Augmented Reality (AR) Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Accessibility Features
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      AI-powered Chatbots
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Pricing Tables
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Content Loading
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Microinteractions
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customer Reviews and Ratings
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Online Payment Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Product Catalog with Filters
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Quizzes
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Personalized User Profiles
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User Account Management
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User-Friendly Search Functionality
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Newsletter and Email Campaign Management
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social Media Feeds Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Client Portal for Collaboration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Resource Library or Knowledge Base
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Portfolio Showcase for Projects
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Timeline or Milestones
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Integration with Third-Party APIs (e.g., Weather, Maps)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Countdown Timers for Events or Sales
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customizable Animations and Transitions
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customizable Progress Bars or Milestones
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      FAQ and Help Center
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Job Board or Listings
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      360-Degree Product Views
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Ratings and Reviews for Products/Services
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Community Forum or Discussion Boards
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Integration with Booking Platforms (e.g., OpenTable)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Real-time Chat and Messaging
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Personalized Recommendations (based on user behavior)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Product Configurators
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User Surveys and Feedback Forms
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Augmented Reality (AR) Product Try-On
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Testimonials or Success Stories
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social Sharing Widgets for Content
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Scroll Animations
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Personalized Content Recommendations
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customizable Data Dashboards
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Data Visualization (Charts, Graphs)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User Notifications and Alerts
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Sliders and Carousels
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </TabPanel>
      </Tabs>

      <Tabs className="tabs-wrapper" defaultindex={0}>
        <p className="tabs-header">Quality meets affordability in every price.</p>
        <TabList>
          {['Basic', 'Standard', 'Premium'].map((tabName, index) => (
            <Tab
              key={tabName}
              className={index === 0 ? 'react-tabs__tab first-tab' : 'react-tabs__tab'}
              // className="tab-item"
              onClick={(e) => {
                const tabItem = e.currentTarget;
                moveSlide(tabItem, index);
              }}
            >
              {tabName}
            </Tab>
          ))}
          <div className="slide" style={slideStyles} />
        </TabList>

        <TabPanel>
          <div className="tabpanel-content">
            {/* <ConfettiContainer /> */}
            <div className="tabpanel-content--column-one">
              <div className="tabpanel-content--column-one-super" />
              <div className="tabpanel-content--front col-basic">
                <div className="ribbon ribbon-top-left"><span>BASIC</span></div>
                <p style={{
                  bottom: '0', fontSize: '15px', padding: '0 15px', position: 'absolute', fontWeight: '700', color: '#fff', width: '100%',
                }}
                >
                  Custom pricing (depending on project complexity)
                </p>
              </div>

              <div className="tabpanel-content--back">
                <h2 style={{ textAlign: 'center' }}>IMPORTANT:</h2>
                <ul>
                  <li>Prices are estimates and can vary based on project requirements.</li>
                  <li>A detailed project scope will be provided before any work begins.</li>
                  <li>Customized packages and pricing are available upon request.</li>
                  <li>
                    Prices do not include domain registration,
                    hosting fees, or third-party software licenses.
                  </li>
                </ul>
                <a
                  className="btn1 btn-11 btn-11__extra-color"
                  style={{
                    position: 'absolute',
                    bottom: '5%',
                  }}
                  onClick={handleAnchorClick}
                  href="/#contact-section"
                >
                  HIRE ME
                  <MdEmail style={{ position: 'relative', width: '20px', minWidth: '20px' }} />
                </a>
              </div>
            </div>

            <div className="tabpanel-content--column-two">
              <div className="col-two-basic-bg" />
              <table>
                <tbody>
                  <tr>
                    <td>
                      Responsive design (up to 5 pages)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Contact form integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Basic SEO optimization
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Hosting setup assistance
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customizable elements (colors, fonts, logo)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social media links integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Image gallery inclusion
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      About and Contact pages
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Blog section setup
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Initial content upload (provided by you)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Basic analytics setup
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="tabpanel-content">
            {/* <ConfettiContainer /> */}
            <div className="tabpanel-content--column-one">
              <div className="tabpanel-content--column-one-flash" />
              <div className="tabpanel-content--front col-standard">
                <div className="ribbon ribbon-top-left"><span>STANDARD</span></div>
                <p style={{
                  bottom: '0', fontSize: '15px', padding: '0 10px', position: 'absolute', fontWeight: '700', color: '#fff', width: '100%',
                }}
                >
                  Custom pricing (depending on project complexity)
                </p>
              </div>

              <div className="tabpanel-content--back">
                <h2 style={{ textAlign: 'center' }}>IMPORTANT:</h2>
                <ul>
                  <li>Prices are estimates and can vary based on project requirements.</li>
                  <li>A detailed project scope will be provided before any work begins.</li>
                  <li>Customized packages and pricing are available upon request.</li>
                  <li>
                    Prices do not include domain registration,
                    hosting fees, or third-party software licenses.
                  </li>
                </ul>
                <a
                  className="btn1 btn-11 btn-11__extra-color"
                  style={{
                    position: 'absolute',
                    bottom: '5%',
                  }}
                  onClick={handleAnchorClick}
                  href="/#contact-section"
                >
                  HIRE ME
                  <MdEmail style={{ position: 'relative', width: '20px', minWidth: '20px' }} />
                </a>
              </div>
            </div>
            <div className="tabpanel-content--column-two">
              <div className="col-two-standard-bg" />
              <table>
                <tbody>
                  <tr>
                    <td>
                      Responsive Design (up to 10 pages)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Content Management System (CMS)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Basic SEO Setup
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Contact Form
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social Media Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Google Analytics Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Stock Images
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Domain and Hosting Assistance
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Security Features
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Contact Form Integration (Advanced Fields)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Comprehensive SEO Optimization
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Hosting Setup Assistance and Configuration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Extensive Customization (Colors, Fonts, Logo)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Image Gallery (Advanced Sorting)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      About Us and Contact Us Pages
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Robust Blog Section Setup (Categories, Tags)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Initial Content Upload (Provided)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Basic Analytics Setup
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="tabpanel-content">
            {/* <ConfettiContainer /> */}
            <div className="tabpanel-content--column-one">
              <div className="tabpanel-content--column-one-crown" />
              <div className="tabpanel-content--front col-premium">
                <div className="ribbon ribbon-top-left"><span>PREMIUM</span></div>
                <p style={{
                  bottom: '0', fontSize: '15px', padding: '0 10px', position: 'absolute', fontWeight: '700', color: '#fff', width: '100%',
                }}
                >
                  Custom pricing (depending on project complexity)
                </p>
              </div>

              <div className="tabpanel-content--back">
                <h2 style={{ textAlign: 'center' }}>IMPORTANT:</h2>
                <ul>
                  <li>Prices are estimates and can vary based on project requirements.</li>
                  <li>A detailed project scope will be provided before any work begins.</li>
                  <li>Customized packages and pricing are available upon request.</li>
                  <li>
                    Prices do not include domain registration,
                    hosting fees, or third-party software licenses.
                  </li>
                </ul>
                <a
                  className="btn1 btn-11 btn-11__extra-color"
                  style={{
                    position: 'absolute',
                    bottom: '5%',
                  }}
                  onClick={handleAnchorClick}
                  href="/#contact-section"
                >
                  HIRE ME
                  <MdEmail style={{ position: 'relative', width: '20px', minWidth: '20px' }} />
                </a>
              </div>
            </div>
            <div className="tabpanel-content--column-two">
              <div className="col-two-premium-bg" />
              <table>
                <tbody>
                  <tr>
                    <td>
                      Design and Development (Up to 15 pages)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Advanced SEO Optimization
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Custom Contact Form
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Google Analytics Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Premium Stock Images
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Enhanced Security Features
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Advanced Contact Form Integration (Conditional Logic)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Comprehensive SEO Strategy (On-page and Off-page)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      E-commerce Integration (if applicable)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Custom Branding and Design (Colors, Fonts, Logo)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Image Gallery (Advanced Sorting, Filtering)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Engaging About Us and Contact Us Pages
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Robust Blog Section Setup (Categories, Tags, Comments)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      Initial Content Upload (Provided)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      In-depth Analytics and Reporting (Custom Event Tracking, Conversions)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Newsletter Signup Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Ongoing Support and Maintenance
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Video Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Infographics
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Live Chat Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Testimonial Showcase
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Multi-language Support
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Integrated Booking System
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User-generated Content
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Event Calendar
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Membership Area
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Maps
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Virtual Tours
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Parallax Scrolling
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customized 404 Page
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Polls and Surveys
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Integrated Blogging Platform
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Gamification Elements
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Product Comparison Tables
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Progressive Web App (PWA) Features
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social Proof Pop-ups
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Augmented Reality (AR) Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Accessibility Features
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      AI-powered Chatbots
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Pricing Tables
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Content Loading
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Microinteractions
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customer Reviews and Ratings
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Online Payment Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Product Catalog with Filters
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Quizzes
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Personalized User Profiles
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User Account Management
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User-Friendly Search Functionality
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Newsletter and Email Campaign Management
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social Media Feeds Integration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Client Portal for Collaboration
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Resource Library or Knowledge Base
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Portfolio Showcase for Projects
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Timeline or Milestones
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Integration with Third-Party APIs (e.g., Weather, Maps)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Countdown Timers for Events or Sales
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customizable Animations and Transitions
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customizable Progress Bars or Milestones
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      FAQ and Help Center
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Job Board or Listings
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      360-Degree Product Views
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Ratings and Reviews for Products/Services
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Community Forum or Discussion Boards
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Integration with Booking Platforms (e.g., OpenTable)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Real-time Chat and Messaging
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Personalized Recommendations (based on user behavior)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Product Configurators
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User Surveys and Feedback Forms
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Augmented Reality (AR) Product Try-On
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Testimonials or Success Stories
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Social Sharing Widgets for Content
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Scroll Animations
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Personalized Content Recommendations
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Customizable Data Dashboards
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Interactive Data Visualization (Charts, Graphs)
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      User Notifications and Alerts
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Dynamic Sliders and Carousels
                      <AiOutlineCheckCircle className="green-checkmark" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
};

export default Prices;
